import {AccountDetailsFormValues} from "../types";
import {TConnectBankApiResponse} from "../../../../../../../react-query-hooks/payout";
import {usePayoutSettingsContext} from "../../context";
import {message} from "antd";
import {useCompleteStripeUpdate} from "../../../../../../../features/bank-accounts/hooks/useStripeActions";
import {useCompleteUpdateBankAccount} from "../../../../../../../features/bank-accounts/hooks/useBankAccounts";

interface HookResult {
  updateBank(values: AccountDetailsFormValues & {otp: string}): void;
  updateStripeBank(values: {otp: string}): void;
  wasBankUpdated: boolean;
  isUpdatingBank: boolean;
  responseData?: TConnectBankApiResponse;
}

export function useUpdateBank(): HookResult {
  const {dispatch} = usePayoutSettingsContext();
  const completeUpdateBankAccountMutation = useCompleteUpdateBankAccount();
  const completeStripeUpdateMutation = useCompleteStripeUpdate();

  // v2 two-step flow: bank details were sent in initiate step, now just send OTP
  function updateBank(values: AccountDetailsFormValues & {otp: string}) {
    completeUpdateBankAccountMutation.mutate(
      {otp: values.otp},
      {
        onSuccess() {
          message.success("Bank updated successfully");
          dispatch({type: "reset-state"});
        },
      }
    );
  }

  function updateStripeBank(values: {otp: string}) {
    completeStripeUpdateMutation.mutate(
      {otpCode: values.otp},
      {
        onSuccess() {
          dispatch({type: "reset-state"});
        },
      }
    );
  }

  return {
    updateBank,
    updateStripeBank,
    wasBankUpdated:
      completeUpdateBankAccountMutation.isSuccess ||
      completeStripeUpdateMutation.isSuccess,
    isUpdatingBank:
      completeUpdateBankAccountMutation.isLoading ||
      completeStripeUpdateMutation.isLoading,
    // responseData not available in v2 complete flow (bank details sent in initiate step)
    responseData: undefined,
  };
}
